import React from 'react';
import gettext from '@eb/gettext';

export default class PrivacyTerms extends React.Component {
    constructor(props) {
        super(props);

        const {
            onTermsOfServiceClick,
            onComunityGuidelinesClick,
            onPrivacyPolicyClick,
        } = this.props;

        this.privacyPolicyNameToHandler = {
            tos: onTermsOfServiceClick,
            'community-guidelines': onComunityGuidelinesClick,
            'privacy-policy': onPrivacyPolicyClick,
        };
    }

    _handlePrivacyPolicyClick = (e) => {
        const targetName = e.target.name;

        if (targetName) {
            const privacyPolicyHandler = this.privacyPolicyNameToHandler[
                targetName
            ];

            if (privacyPolicyHandler) {
                privacyPolicyHandler();
            }
        }
    };

    render() {
        return (
            <div className="privacy-terms eds-text--center">
                <span
                    className="eds-text-color--grey-1000 eds-text-bs eds-l-mar-bot-5"
                    onClick={this._handlePrivacyPolicyClick}
                    onKeyDown={this._handlePrivacyPolicyClick}
                    role="presentation"
                    // Needed for links to work in gettext; no user-generated content
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            'I accept the <a href="/tos" class="eds-link" target="_blank" name="tos" rel="noopener noreferrer">Eventbrite  Terms of Service</a>, <a href="/community-guidelines" class="eds-link" name="community-guidelines" target="_blank" rel="noopener noreferrer">Community Guidelines</a> and have read the <a href="/privacypolicy" class="eds-link" name="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
                        ),
                    }}
                />
            </div>
        );
    }
}
